export default {
  AvailableStartTime: 'Available StartTime',
  AvailableStartTimeMin: 'Available StartTime Min',
  AvailableStartTimeMax: 'Available StartTime Max',
  AvailableExpireTime: 'Available ExpireTime',
  AvailableExpireTimeMin: 'Available ExpireTime Min',
  AvailableExpireTimeMax: 'Available ExpireTime Max',
  CashAmount: 'Cash Amount',
  CommandNumber: 'Command Number',
  CommandTime: 'Command Time',
  CommandTimeMin: 'CommandTime Min',
  CommandTimeMax: 'CommandTime Max',
  CompanyDiscountAmount: 'Courier Discount Amount',
  CompanyDiscountAmountMin: 'Courier Discount Amount Min',
  CompanyDiscountAmountMax: 'Courier Discount Amount Max',
  CompanyDiscountTypeId: 'CompanyDiscount Type',
  Coupones: 'Coupones',
  Companies: 'Couriers',
  CarModels: 'CarModels',
  CarLoads: 'CarLoads',
  Employees: 'Employees',
  Addons: 'Addons',
  ItemGroups: 'ItemGroups',
  Items: 'Items',
  ItemsFeature: 'ItemsFeature',
  Loads: 'Loads',
  Packages: 'Packages',
  CarModelFeatures: 'CarModelFeatures',
  Enabled: 'Enabled',
  ExcludePromotion: 'ExcludePromotion',
  ExcludeCampaign: 'ExcludeCampaign',
  FirstOrder: 'First Order',
  GiftAmount: 'Gift Amount',
  MaximumUse: 'Maximum Use',
  MaximumUseMin: 'Maximum Use Min',
  MaximumUseMax: 'Maximum Use Max',
  Keywords: 'Keywords',
  MaximumCompanyDiscountAmount: 'Maximum Courier Discount Amount',
  MaximumCompanyDiscountAmountMin: 'Maximum Courier Discount Amount Min',
  MaximumCompanyDiscountAmountMax: 'Maximum Courier Discount Amount Max',
  MarketplaceDiscountAmount: 'Marketplace Discount Amount',
  MarketplaceDiscountAmountMin: 'Marketplace Discount Amount Min',
  MarketplaceDiscountAmountMax: 'Marketplace Discount Amount Max',
  MaximumMarketplaceDiscountAmount: 'Maximum Marketplace Discount Amount',
  MaximumMarketplaceDiscountAmountMin:
    'Maximum Marketplace Discount Amount Min',
  MaximumMarketplaceDiscountAmountMax:
    'Maximum Marketplace Discount Amount Max',
  MinimumOrderAmount: 'Minimum Order Amount',
  MinimumOrderAmountMin: 'Minimum Order Amount Min',
  MinimumOrderAmountMax: 'Minimum Order Amount Max',
  MarketplaceDiscountTypeId: 'MarketplaceDiscount Type',
  Organization: 'Organization',
  Percent: 'Percent',
  Reusable: 'Reusable',
  Title: 'Title',
  Pin: 'Pin',
  PinLength: 'Pin Length',
  Quantity: 'Quantity',
  ShowAndroid: 'show Android',
  ShowIOS: 'show IOS',
  ShowWeb: 'show Web',
  ShowWebService: 'show WebService',
  SortOrder: 'SortOrder',
  ShowOn: 'Show On',
  Slug: 'Slug',
  Used: 'Used',
  discountCouponType: 'discount coupon type',
  discountCoupons: 'Discount coupons',

  commandNumber: 'Command Number',
  companyDiscountAmount: 'Courier discount amount',
  marketplaceDiscountAmount: 'Marketplace discount amount',
  maximumMarketplaceDiscountAmount: 'Maximum marketplace discount amount',
  maximumCompanyDiscountAmount: 'Maximum courier discount amount',
  minimumOrderAmount: 'Minimum order amount',
  maximumUse: 'Maximum use',
  reusable: 'Reusable',
  firstOrder: 'First order',
  excludePromotion: 'Exclude promotion',
  excludeCampaign: 'Exclude campaign',
  showWeb: 'Show web',
  showAndroid: 'Show android',
  showIOS: 'show IOS',
  showWebService: 'show web service',
  marketplaceDiscountTypeId: 'MarketplaceDiscount Type',
  companyDiscountTypeId: 'CompanyDiscount Type',
  availableStartTime: 'Available start time',
  availableExpireTime: 'Available expireTime',
  keywords: 'Keywords',
  companies: 'Couriers',
  carModels: 'Car models',
  carModelFeatures: 'Car model features',
  carLoads: 'CarLoads',
  employees: 'Employees',
  itemGroups: 'Item groups',
  items: 'Items',
  itemsFeature: 'Items feature',
  loads: 'Loads',
  packages: 'Packages',
  organization: 'Organization',

  cashAmount: 'Cash amount',
  giftAmount: 'Gift amount',
  commandTime: 'Command time',
  showOn: 'Show on',
  coupon: 'Coupon',
  used: 'Used',
  pin: 'Pin',
  quantity: 'Quantity',
  deadlineTime: 'Deadline time',
  minimumMarketplaceDiscount: 'Minimum marketplace discount',
  maximumMarketplaceDiscount: 'Maximum marketplace discount',
  MinimumCompanyDiscount: 'Minimum courier discount',
  MaximumCompanyDiscount: 'Minimum courier discount',
  pinLength: 'Pin Length'
}
